import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css'; // Import styles

const Navbar = () => {
    return (
        <nav>
            <ul>
                <li><Link to="/">خانه</Link></li>
                <li><Link to="#">زندگی نامه</Link></li>
                <li><Link to="/vasiyatNaameh">وصیت نامه</Link></li>
                <li><Link to="/about">به روایت دیگران</Link></li>
            </ul>
        </nav>
    );
};

export default Navbar;
